import React from 'react'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { ResponsiveGrid } from '@/components/frontend/atoms/layout/ResponsiveGrid'
import { BlogPostCard } from '@/components/frontend/molecules/BlogPostCard'
import { BlogPagination } from '@/components/frontend/molecules/BlogPagination'
import { EmptyFeed } from '@/components/frontend/atoms/feedback/EmptyFeed'
import { useTranslation } from '@/hooks/useTranslation'
import type { PublicPost, BlogPagination as BlogPaginationType } from '@/types/frontend'

interface PostFeedProps {
  posts: PublicPost[]
  pagination: BlogPaginationType
  activeTag?: string | null
  search?: string
}

export const PostFeed: React.FC<PostFeedProps> = ({ posts, pagination, activeTag, search }) => {
  const { t, lp } = useTranslation()

  if (posts.length === 0) {
    return <EmptyFeed message={t('blog.empty')} />
  }

  return (
    <Stack gap="8">
      <ResponsiveGrid cols="3" gap="4">
        {posts.map((post) => (
          <BlogPostCard key={post.id} post={post} />
        ))}
      </ResponsiveGrid>
      <BlogPagination pagination={pagination} basePath={lp('/blog')} activeTag={activeTag} search={search} />
    </Stack>
  )
}
